import React from 'react';
import { Pressable, View, Text, StyleSheet } from 'react-native';
import { useTheme } from '@react-navigation/native';

const CustomCheckbox = ({ label, value, onValueChange, fontSize }) => {
  const { colors } = useTheme();
  const styles = makeStyles(colors);

  return (
    <Pressable
      style={styles.row}
      onPress={() => onValueChange(!value)}
      hitSlop={8}
      accessibilityRole="checkbox"
      accessibilityState={{ checked: value }}
    >
      <View style={[styles.box, value && styles.boxChecked]}>
        {value && <Text style={styles.check}>✓</Text>}
      </View>
      {label && <Text style={styles.label}>{label}</Text>}
    </Pressable>
  );
};

const makeStyles = (colors, fontSize) => StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
    alignSelf: 'center',
  },
  box: {
    width: 22,
    height: 22,
    borderRadius: 4,
    borderWidth: 2,
    borderColor: colors.green_dark,
    alignItems: 'center',
    justifyContent: 'center',
  },
  boxChecked: {
    backgroundColor: colors.green,
    borderColor: colors.green
  },

  check: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 16
  },
  label: {
    marginHorizontal: 10,
    fontSize: fontSize ?? 16,
    fontWeight: '700',
  },
});

export default CustomCheckbox;